<div>
  <button class="!float-right rounded-full no-border" mat-dialog-close>
    <mat-icon class="!border-none !overflow-hidden">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-mdc-dialog-surface mdc-dialog__surface">
  <iframe [src]="googleMapsUrl" width="100%" height="100%" allowfullscreen>
  </iframe>
</mat-dialog-content>
